import React from "react";
import { makeStyles } from "@mui/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import { NavLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "90%",
    margin: "0 auto",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  linkColor: {
    "&:hover": {
      color: theme.palette.type === "dark" ? "white" : "black",
    },
    color: theme.palette.type === "dark" ? "white" : "black",
  },
  activeClassName: {
    backgroundColor: theme.palette.primary.light,
    color: "white",
  },
}));

export default function NestedList({ route }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  // const renderChildernList = () => {

  // }

  return (
    <>
      <ListItem
        style={{
          display: "flex",
          padding: "8px",
          alignItems: "center",
          borderRadius: "7px",
        }}
        onClick={handleClick}
      >
        <ListItemIcon>{route.icon}</ListItemIcon>
        <ListItemText primary={route.label} />

        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding dense>
          {route.children.map((child, index) => {
            return child.children ? (
              <NestedList key={index} route={child} />
            ) : (
              <NavLink
                exact={child.exact}
                key={index}
                to={child.link}
                style={{
                  display: "flex",
                  padding: "8px",
                  //   alignItems: "center",
                  borderRadius: "7px",
                }}
                className={({ isActive }) =>
                  isActive ? classes.activeClassName : classes.linkColor
                }
              >
                <ListItemIcon>{child.icon}</ListItemIcon>
                <ListItemText primary={child.label} />
              </NavLink>
            );
          })}
        </List>
      </Collapse>
    </>
  );
}
